class ArticleMediaContent extends HTMLElement {
  connectedCallback() {
    if (this.dataset.mediaFallbackReady === 'true') return;
    this.dataset.mediaFallbackReady = 'true';

    const fallbackSource = this.dataset.imageFallback;
    const fallbackAlt = this.dataset.imageFallbackAlt || '';

    this.querySelectorAll('img').forEach((image) => {
      const handleError = () => {
        if (fallbackSource && image.dataset.fallbackAttempted !== 'true') {
          image.dataset.fallbackAttempted = 'true';
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = fallbackSource;
          if (!image.alt) image.alt = fallbackAlt;
          return;
        }

        image.classList.add('article-content__image-unavailable');
        image.setAttribute('aria-hidden', 'true');
        image.alt = '';
      };

      image.addEventListener('error', handleError);

      if (image.complete && image.naturalWidth === 0) {
        handleError();
      }
    });
  }
}

if (!customElements.get('article-media-content')) {
  customElements.define('article-media-content', ArticleMediaContent);
}
